import axios from "@/axios.js";

export default {
  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("API/Lookup/AddUintModels", item)
        .then(response => {
          debugger;
          resolve(response);
          commit(
            "ADD_ITEM",
            Object.assign(item, { ID: response.data.data.ID })
          );
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  fetchDataListItems({ commit }) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .get("API/Lookup/GetAllUintModels")
        .then(response => {
          debugger;
          resolve(response);
          commit("SET_UintModels", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  SearchUnitOwner({ commit }, search) {
    return new Promise((resolve, reject) => {
      axios
        .post("API/UnitOwner/SearchUnitOwner", search)
        .then(response => {
          resolve(response);
          commit("SET_UintModels", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateItem(context, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
        .put("API/Lookup/UpdateUintModels", item)
        .then(response => {
          resolve(response);
         // commit("UPDATE_UnitOwner", item);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  GetItemByID(context, itemid) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
      .get("API/Lookup/GetUintModelsById?Id=" + itemid)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  DeleteObject({ commit }, item) {
    debugger;
    return new Promise((resolve, reject) => {
      axios
      .delete("API/Lookup/DeleteUintModels?Id=" + item.id)
        .then(response => {
          resolve(response);
          commit("REMOVE_ITEM", item.id);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  UploadImage(context, image) {
    const formData = new FormData();
    formData.append("file",image, image.name);
    return new Promise((resolve, reject) => {
      axios
        .post("/API/Common/UploadFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.status == 200) {
            resolve(response);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
